<template>
  <div class="matches">
    <v-text-field
      class="input"
      color="green"
      placeholder="Chat suchen ..."
      solo
      rounded
      append-icon="search"
    ></v-text-field>

    <div v-if="matchesArchived.length" class="scrolling-wrapper-top">
      <h4>Inaktive Chats</h4>
      <div
        v-if="matchesArchived && matchesArchived.length"
        class="scrolling-wrapper-flexbox"
        style="margin-top: 10px"
      >
        <ChatInactivePreview
          @click="
            redirectToChat(
              matchChat.chat_id,
              matchChat.logo,
              matchChat.team ? matchChat.team : matchChat.name,
              matchChat.contactByDetails,
            )
          "
          v-for="matchChat in matchesArchived"
          :key="matchChat.chat_id"
          :picture="matchChat.logo"
          :msg="matchChat.lastMessage"
          :chat-id="matchChat.chat_id"
          :name="matchChat.team ? matchChat.team : matchChat.name"
          :lastMessageDetails="matchChat.lastMessageDetails"
          :inactiveInfo="matchChat.disabledBy"
          :details="matchChat.contactByDetails"
        ></ChatInactivePreview>
      </div>
      <v-divider class="divider"></v-divider>
    </div>

    <h3 v-if="noUserMatches">Im Moment hast du keine aktiven Chats.</h3>

    <h2 v-if="teamChats.length !== 0">Vereine</h2>
    <ChatPreview
      @click="
        redirectToChat(
          matchChat.chat_id,
          matchChat.logo,
          matchChat.team ? matchChat.team : matchChat.name,
          matchChat.contactByDetails,
        )
      "
      @open-profile="openProfile(matchChat.contactByDetails, matchChat.chat_id)"
      class="player-preview"
      v-for="matchChat in teamChats"
      :key="matchChat.chat_id"
      :picture="matchChat.logo"
      :msg="matchChat.lastMessage"
      :chat-id="matchChat.chat_id"
      :name="matchChat.team ? matchChat.team : matchChat.name"
      :lastMessageDetails="matchChat.lastMessageDetails"
      :inactiveInfo="matchChat.disabledBy"
    ></ChatPreview>

    <h2 v-if="scoutsChats.length !== 0">Scouts</h2>
    <ChatPreview
      @click="
        redirectToChat(
          matchChat.chat_id,
          matchChat.logo,
          matchChat.team ? matchChat.team : matchChat.name,
          matchChat.contactByDetails,
        )
      "
      @open-profile="openProfile(matchChat.contactByDetails, matchChat.chat_id)"
      class="player-preview"
      v-for="matchChat in scoutsChats"
      :key="matchChat.chat_id"
      :picture="matchChat.logo"
      :msg="matchChat.lastMessage"
      :chat-id="matchChat.chat_id"
      :name="matchChat.team ? matchChat.team : matchChat.name"
      :lastMessageDetails="matchChat.lastMessageDetails"
      :inactiveInfo="matchChat.disabledBy"
    ></ChatPreview>

    <MatchSheetPlayer
      v-if="showProfile.player"
      :selectedProfile="selectedProfile"
      @close="showProfile.player = false"
      :show="showProfile.player"
      :showMatchButtons="false"
    ></MatchSheetPlayer>

    <MatchSheetTrainer
      v-if="showProfile.trainer"
      :selectedProfile="selectedProfile"
      @close="showProfile.trainer = false"
      :show="showProfile.trainer"
      :showMatchButtons="false"
    ></MatchSheetTrainer>

    <MatchSheetTeam
      v-if="showProfile.teams"
      :selectedProfile="selectedProfile"
      @close="showProfile.teams = false"
      :show="showProfile.teams"
      :showMatchButtons="false"
    ></MatchSheetTeam>

    <MatchSheetScout
      v-if="showProfile.scout"
      :selectedProfile="selectedProfile"
      @close="showProfile.scout = false"
      :show="showProfile.scout"
      :showMatchButtons="false"
    ></MatchSheetScout>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import ChatPreview from '@/components/chat/ChatPreview';
import ChatInactivePreview from '@/components/chat/ChatInactivePreview';
import matchMixin from '../../mixins/match';
import chatProfiles from '../../mixins/chat-profiles';
import common from '../../mixins/common';

export default {
  name: 'player-matches',

  components: {
    ChatPreview,
    ChatInactivePreview,
  },

  mixins: [matchMixin, chatProfiles, common],

  computed: {
    ...mapState(['user_data', 'userMatches']),

    matchesActive() {
      return this.userMatches
        ? _.orderBy(
            this.userMatches.filter(
              (m) => !m.disabledBy || !m.disabledBy.includes(this.user_data.id),
            ),
            ['timestamp'],
            ['desc'],
          )
        : [];
    },

    scoutsChats() {
      return this.userMatches
        ? _.orderBy(
            this.userMatches
              .filter((m) => m.contactByDetails.type === 'scout')
              .filter(
                (m) => !m.disabledBy || !m.disabledBy.includes(this.user_data.id),
              ),
            ['timestamp'],
            ['desc'],
          )
        : [];
    },

    teamChats() {
      return this.userMatches
        ? _.orderBy(
            this.userMatches
              .filter((m) => m.contactByDetails.type === 'teams')
              .filter(
                (m) => !m.disabledBy || !m.disabledBy.includes(this.user_data.id),
              ),
            ['timestamp'],
            ['desc'],
          )
        : [];
    },

    matchesArchived() {
      return this.userMatches
        ? this.userMatches.filter(
            (m) => m.disabledBy && m.disabledBy.includes(this.user_data.id),
          )
        : [];
    },

    noUserMatches() {
      return !this.userMatches || (this.userMatches && this.userMatches.length === 0);
    },
  },

  async beforeMount() {
    // refresh last messages
    await this.fetchChats(this.user_data.matches);
  },
};
</script>
